<template>
  <o-card :title="$t('core.your_info')">
    <form @submit.prevent="update" @keydown="form.onKeydown($event)">
      <alert-success :form="form" :message="$t('core.info_updated')"></alert-success>

      <!-- Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.name') }}</label>
        <div class="col-md-7">
          <input v-model="form.name" type="text" name="name" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('name') }">
          <has-error :form="form" field="name"></has-error>
        </div>
      </div>

      <!-- First Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.first_name') }}</label>
        <div class="col-md-7">
          <input v-model="form.first_name" type="text" name="first_name" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('first_name') }">
          <has-error :form="form" field="first_name"></has-error>
        </div>
      </div>

      <!-- Second Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.second_name') }}</label>
        <div class="col-md-7">
          <input v-model="form.second_name" type="text" name="second_name" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('second_name') }">
          <has-error :form="form" field="second_name"></has-error>
        </div>
      </div>

      <!-- Email -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.email') }}</label>
        <div class="col-md-7">
          <input v-model="form.email" type="email" name="email" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('email') }">
          <has-error :form="form" field="email"></has-error>
        </div>
      </div>

      <!-- Phone -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.phone') }}</label>
        <div class="col-md-7">
          <input v-model="form.phone" type="tel" name="phone" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('phone') }">
          <has-error :form="form" field="phone"></has-error>
        </div>
      </div>

      <!-- key -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('sandoz.key') }}</label>
        <div class="col-md-7">
          <input v-model="form.key" type="text" name="key" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('key') }">
          <has-error :form="form" field="key"></has-error>
        </div>
      </div>

      <!-- vertical_forms -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.vertical_forms') }}</label>
        <div class="col-md-7 form-check">
          <div class="form-check">
            <input v-model="form.vertical_forms" class="form-check-input" type="radio" name="vertical_forms" :class="{ 'is-invalid': form.errors.has('vertical_forms') }" :value="false">
            <label class="form-check-label">
              {{$t('core.horizontal')}}
            </label>
          </div>
          <div class="form-check">
            <input v-model="form.vertical_forms" class="form-check-input" type="radio" name="vertical_forms" :class="{ 'is-invalid': form.errors.has('vertical_forms') }" :value="true">
            <label class="form-check-label">
              {{$t('core.vertical')}}
            </label>
          </div>
          <has-error :form="form" field="key"></has-error>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label">{{ $t('core.timezone') }}</label>
        <div class="col-md-7">
          <o-value-select-search ref="productMasterSelector" :items="timeZoneListDropDown"
                              v-model="form.timezone" :value-field="'value'" :text-field="'text'"/>
          <has-error :form="form" field="key"></has-error>
        </div>
      </div>

      <!-- key -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right"></label>
        <div class="col-md-7">
          <div class="w-100">
            <b-form-checkbox v-model="enable2FA" :value="true" :unchecked-value="false" @change="check2FAChange">
              {{$t('sandoz.enable_two_factor_authentication')}}
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="getQRCode && !twoFAAuthenticated">
        <label class="col-md-3 col-form-label text-md-right"></label>
        <div class="col-md-7">
          <p>{{ $t('sandoz.two_factor_info') }}</p>
          <div style="width:40%">
            <img :src="qrCode" v-if="qrCode"/>
            <input v-model="twoFAPassword" type="password" class="form-control mt-1"
              :class="!validation ? 'is-invalid': ''" :state="validation" :placeholder="$t('sandoz.two_factor_verification_code')">
            <has-error :form="form" field="key"></has-error>
            <b-form-invalid-feedback :state="validation">
              {{ $t('sandoz.two_factor_confirmation_error') }}
            </b-form-invalid-feedback>
            <button type="button" class="btn btn btn-primary btn-md mt-2" @click="confirmPassword">{{ $t('sandoz.validate_2FA') }}</button>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <o-button type="success" :loading="form.busy">{{ $t('core.update') }}</o-button>
        </div>
      </div>
    </form>
  </o-card>
</template>

<script>
  import Form from 'vform'
  import {mapGetters} from 'vuex'
  import axios from 'axios'
  import moment from 'moment-timezone';

  export default {
    data: () => ({
      enable2FA: false,
      getQRCode: false,
      twoFAAuthenticated: false,
      twoFAPassword: '',
      qrCode: '',
      validation: true,
      timeZoneListDropDown: [],
      form: new Form({
        name: '',
        email: '',
        phone: '',
        first_name: '',
        second_name: '',
        key: '',
        is_enable_2FA: false,
        vertical_forms: false,
        timezone:''
      })
    }),

    computed: {
      ...mapGetters({
        user: 'auth/user'
      }),
    },

    created() {
      // Fill the form with user data.
      this.form.keys().forEach(key => { 
        this.form[key] = this.user[key]
      })

      this.enable2FA = this.form.is_enable_2FA
      moment.tz.names().forEach(key => { 
        let object = {value: key, text: key}
        this.timeZoneListDropDown.push(object)
      })
    },
    methods: {
      async update() {
        const {data} = await this.form.patch('/api/settings/profile')
        data.key = ''
        this.$store.dispatch('auth/updateUser', {user: data})
      },
      check2FAChange() {
        if (this.enable2FA && !this.form.is_enable_2FA) {
          this.showQrCode()
        } else {
          this.getQRCode = false
          this.form.is_enable_2FA = false
          this.twoFAAuthenticated = false
        }
      },
      showQrCode () {
        var data = { user_id: this.user.id }
        return axios.post('/api/settings/generate-code', data)
        .then(response => {
          this.qrCode = response.data.path
          this.getQRCode = true
        })
      },
      confirmPassword() {

        if(this.twoFAPassword === '') {
          this.validation = false
        }

        axios.post('/api/settings/confirm-password', {
            password: this.twoFAPassword,
            user_id: this.user.id
        }).then(response => {
            if(response.data.success) {
              this.twoFAAuthenticated = true
              this.form.is_enable_2FA = true
              this.update()
            } else {
              this.validation = false
            }
        })
      }
    }
  }
</script>
